import Button from "../../Shared/Button"
import Input from "../../Shared/Input"
import TextArea from "../../Shared/TextArea"
import { useFormik } from "formik";
import { useMutation } from "@tanstack/react-query";
import * as Yup from "yup";
import { AxiosError } from "axios";
import { ButtonTypes } from "../../../utils/consts";
import Spinner from "../../Shared/Spinner";
import { toast } from 'react-toastify';
import { queryClient } from "../../../main";
import Upload from "../../Shared/Upload";
import { useParams } from "react-router-dom";
import { AddNewCategory } from "../../../api/Categories/AddCategory";

const validationSchema = Yup.object({
    name: Yup.string()
        .required("Category name is required"),
    description: Yup.string()
        .required("Category description is required"),
    img_url: Yup.string()
        .required("Display Image is required"),
});

const AddCategory = ({ onSuccess }: { onSuccess?: () => void }) => {
    const { id } = useParams()

    const { mutate, error, isPending } = useMutation({
        mutationFn: AddNewCategory,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["categories"] });
            toast.success("Category Added successfully");
            formik.resetForm();
            onSuccess && onSuccess();
        },
        onError: () => {
            formik.setSubmitting(false);
        },
    });
    const formik = useFormik({
        initialValues: {
            name: "",
            description: "",
            img_url: "",
        },
        validationSchema,
        onSubmit: (values) => {
            mutate(values);
        },
    });

    const handleimgUrlUpload = (url: string) => {
        formik.setFieldValue('img_url', url);
    };


    return (
        <form onSubmit={formik.handleSubmit}
            className="pt-5">
            <div className="flex justify-between mb-6">
                <h1 className="text-burntBlack font-bold text-[32px] mt-5">{id ? 'Edit course' : 'Upload new course'}</h1>
            </div>
            <div className="p-8 rounded-3xl shadow bg-white border border-black/15 min-h-[70vh] flex gap-16">
                <div className="w-full">
                    <h1 className="mb-2.5 font-bold text-2xl">Category info</h1>
                    <p className="text-lightGray font-medium">Add Category details to help students discover your category and better
                        understand what they will learn. what they will need and expect</p>
                    <div className="space-y-7 pt-8">
                        <Input
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                                formik.touched.name && formik.errors.name
                                    ? formik.errors.name
                                    : ""
                            }
                            className="text-lg font-semibold"
                            inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
                            title="Category Title"
                            placeholder=""
                            name="name"
                            type="text"
                        />
                        <TextArea
                            value={formik.values.description}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                                formik.touched.description && formik.errors.description
                                    ? formik.errors.description
                                    : ""
                            }
                            name="description" title="Category Description" placeholder="" inputStyles="!bg-[#F5F6F8] !h-[224px] border-black/15"
                        />
                            <Upload folder="categories_images" onFileUploaded={handleimgUrlUpload}>
                            <Input
                                upload={true}
                                className="text-lg font-semibold"
                                inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
                                placeholder=""
                                title="Category Image"
                                name="img_url"
                                type="text"
                                value={formik.values.img_url}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.img_url && formik.errors.img_url
                                        ? formik.errors.img_url
                                        : ""
                                }
                            />

                        </Upload>

                        {error instanceof AxiosError && (
                            <span className="text-red-500 font-bold text-lg">
                                {error?.response?.data?.message || "An error occurred"}
                            </span>
                        )}
                        <Button className="!h-14 w-full !text-lg font-bold rounded-md !bg-[#4379EE] hover:!bg-primary" variant="primary" type={ButtonTypes.SUBMIT}
                            disabled={formik.isSubmitting || isPending }
                        >Done           {isPending ? (
                            <Spinner />) : ('')}
                        </Button>

                    </div>
                </div>
            </div>
        </form>
    )
}

export default AddCategory